<template>
  <v-container>
    <v-row v-if="exercises && exercises.length">
      <v-col v-for="exercise in exercises" :key="exercise.id" cols="12" sm="4">
        <v-card outlined>
          <v-card-text
            class="pb-0 exercise-card"
            @click="openExercise(exercise.id)"
          >
            <div
              class="text-h6 font-weight-regular text--primary mb-1"
              style="opacity: 0.8"
            >
              {{ exercise.problemTitle }}
            </div>

            <v-divider></v-divider>
            <embed
              v-if="getPDFUrl(exercise.id)"
              :src="getPDFUrl(exercise.id) + '?#toolbar=0'"
              style="width: 100%; height: 120px"
            />
            <div v-else class="text-center">
              <img
                src="@/assets/Images/undraw/no_subscription.svg"
                style="max-height: 120px"
              />
            </div>
            <v-divider class="mb-0"></v-divider>
          </v-card-text>
          <v-card-actions class="py-0">
            <v-row class="d-flex justify-center">
              <v-col>
                <v-btn
                  icon
                  color="tertiary"
                  :disabled="!getPDFUrl(exercise.id)"
                  @click="openExerciseView(exercise.id)"
                  class="mx-2"
                >
                  <v-icon> mdi-magnify </v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="attention"
                  @click="changeExercise(exercise.id)"
                  class="mx-2"
                >
                  <v-icon> mdi-pencil </v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="alert"
                  @click="deleteExercise(exercise.id)"
                  class="mx-2"
                >
                  <v-icon> mdi-delete </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card></v-col
      >
    </v-row>
    <div v-else class="text-center">
      <img
        src="@/assets/Images/undraw/no_subscription.svg"
        style="max-height: 300px"
      />
      <div class="text-caption pt-3 text--secondary">
        Hier gibt es noch keine Übungen.
      </div>
    </div>
  </v-container>
</template>

<style scoped>
.exercise-card {
  cursor: pointer;
}
</style>

<script>
import { useUserServiceInject } from "@/context";
import { baseUrl } from "@/constants";

export default {
  name: "ExerciseCards",
  props: ["exercises"],
  setup() {
    const { loggedIn, isStaff } = useUserServiceInject();
    return { loggedIn, isStaff };
  },
  methods: {
    openExercise(exerciseId) {
      const pdfURL = this.getPDFUrl(exerciseId);
      if (!pdfURL.length) return;
      window.open(this.getPDFUrl(exerciseId), "_blank").focus();
    },
    changeExercise(exerciseId) {
      if (!this.isStaff) {
        return;
      }
      this.$router.push({
        name: "update.exercise",
        params: { id: exerciseId },
      });
    },
    deleteExercise(exerciseId) {
      if (confirm("Wollen Sie diese Übung wirklich löschen?")) {
        this.$axios
          .delete("exercises/" + exerciseId)
          .then(
            () =>
              (this.exercises = this.exercises.filter(
                (e) => e.id != exerciseId
              ))
          );
      }
    },
    getPDFUrl(exerciseId) {
      const exercise = this.getExerciseById(exerciseId);
      if (!exercise) {
        return "";
      }
      if (!exercise.compiledFile) {
        return "";
      }
      let path = exercise.compiledFile;
      if (path.startsWith("/")) {
        path = path.replace("/", "");
      }
      return baseUrl + path;
    },
    getExerciseById(exerciseId) {
      if (!this.exercises) {
        return undefined;
      }
      return this.exercises.find((e) => e.id == exerciseId);
    },
    openExerciseView(exerciseId) {
      this.$router.push({
        name: "exercise",
        params: {
          id: exerciseId,
        },
      });
    },
  },
};
</script>
